import * as e from "react";
const c = ({
  title: a,
  titleId: l,
  ...m
}) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": l,
    ...m
  },
  a ? /* @__PURE__ */ e.createElement("title", { id: l }, a) : null,
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 20c.114 0 .871-.193 1.715-2.05.37-.814.684-1.814.91-2.95h-5.25c.226 1.136.54 2.136.91 2.95C11.13 20.808 11.885 21 12 21m-2.91-7a22 22 0 0 1 0-4h5.82a22 22 0 0 1 0 4zm7.57 2c-.306 1.721-.803 3.232-1.434 4.405A9.03 9.03 0 0 0 20.064 16zm4.117-2h-3.86a24 24 0 0 0 0-4h3.86a9 9 0 0 1 0 4M7.082 14H3.223a9 9 0 0 1 0-4h3.86a24 24 0 0 0 0 4m-3.146 2H7.34c.305 1.721.802 3.232 1.433 4.405A9.03 9.03 0 0 1 3.936 16m5.44-8h5.248c-.225-1.136-.539-2.136-.91-2.95C12.872 3.192 12.115 3 12 3s-.871.193-1.715 2.05c-.37.814-.684 1.814-.91 2.95m7.283 0h3.406a9.03 9.03 0 0 0-4.84-4.405C15.858 4.768 16.355 6.28 16.66 8M8.774 3.595C8.144 4.768 7.646 6.28 7.341 8H3.936a9.03 9.03 0 0 1 4.838-4.405",
      clipRule: "evenodd"
    }
  )
);
export {
  c as default
};
